module.exports = __webpack_public_path__ + "img/united.3bc3e4ca.png";